import {
  Avatar,
  Button,
  CircularProgress,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  Button as AntdButton,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Input,
  message,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import { Alert } from "components/Alert/Alert";
import { Controller } from "Controller/Controller";
import { Rules } from "errorHandling/Rules";
import { useEffect, useMemo, useState } from "react";
import { FaPlus } from "react-icons/fa";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { NavLink } from "react-router-dom";

const { Option } = Select;
const { Search } = Input;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function MemberTable(props) {
  // windows width
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);

  useEffect(() => {
    checkAccount();

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { columnsData, tableData } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const data = useMemo(() => tableData, [tableData]);
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;

  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");

  const handleCloseEditMember = async () => {
    setOpenModalEdit(false);
    setBasicEditValues({
      first_name: "",
      last_name: "",
      contact_first_name: "",
      contact_last_name: "",
      business_name: "",
      address: "",
      city: "",
      state: "",
      email: "",
      phone: "",
      business_email: "",
      business_phone: "",
      contact_email: "",
      contact_phone: "",
      zip_code: "",
      country: "ca",
      dateOfBirth: null,
    });
  };

  const handleDeleteMember = async (id) => {
    console.log(id);
    const response =
      props.memberType == "business"
        ? await Controller.deleteBusinessMember(id)
        : await Controller.deleteMember(id);

    if (response.status < 250) {
      message.success(
        props.memberType == "business"
          ? "Business Member deleted successfully!"
          : "Member deleted successfully!"
      );
      props.getMemberData();
    } else {
      message.error("Error deleting member");
    }
  };

  const [position, setPosition] = useState("add");
  // state
  const [basicEditValues, setBasicEditValues] = useState({
    first_name: "",
    last_name: "",
    contact_first_name: "",
    contact_last_name: "",
    business_name: "",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    business_email: "",
    business_phone: "",
    contact_email: "",
    contact_phone: "",
    zip_code: "",
    country: "ca",
    dateOfBirth: null,
    id: -1,
  });
  const [visibleCreateMemberModal, setVisibleCreateMemberModal] =
    useState(false);
  const [newMember, setNewMember] = useState({
    first_name: "",
    last_name: "",
    business_name: "",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    zip_code: "",
    country: undefined,
    dateOfBirth: null,
    contact_person: {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    },
  });
  const [permission, setPermission] = useState("loading");

  // functions

  const checkAccount = async () => {
    const response = await Controller.checkConnectedAccount();
    if (!response.detail) {
      setPermission(false);
    } else if (!response.detail.is_verified) {
      setPermission(false);
    } else {
      setPermission(false);
    }
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setBasicEditValues({
      ...basicEditValues,
      [name]: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setNewMember((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setNewMember({
        ...newMember,
        [name]: value,
      });
    }
  };

  const handleEditMember = async () => {
    setLoadingCreate(true);

    if (props.memberType == "business") {
      try {
        const temp = {
          business_name: basicEditValues.business_name,
          ...basicEditValues,
          id: basicEditValues.id,
          zip_code: basicEditValues?.zip_code,
          contact_person: {
            first_name: basicEditValues?.contact_first_name,
            email: basicEditValues?.contact_email,
            phone: basicEditValues?.contact_phone,
            last_name: basicEditValues?.contact_last_name,
          },
          //"fullname": basicEditValues.first_name + " " + basicEditValues.last_name,
          //address1: basicEditValues.address,
          //postalCode: basicEditValues.zip_code,
        };

        delete temp.customer_plan;
        delete temp.profile_picture;
        delete temp.id;

        const response = await Controller.editBusinessMember(
          temp,
          basicEditValues.id
        );
        if (response.status < 250) {
          Alert.openNotification(
            response?.message ? response?.message : "Successful",
            "success"
          );
          props.getMemberData();
          setOpenModalEdit(false);
          setBasicEditValues({
            first_name: "",
            last_name: "",
            contact_first_name: "",
            contact_last_name: "",
            business_name: "",
            address: "",
            city: "",
            state: "",
            email: "",
            phone: "",
            business_email: "",
            business_phone: "",
            contact_email: "",
            contact_phone: "",
            zip_code: "",
            country: "ca",
            dateOfBirth: null,
          });
        } else {
          Alert.openNotification(
            response?.detail
              ? response.detail[0]
              : response?.address
              ? "Address: " + response.address[0]
              : response?.business_name
              ? "Business Name: " + response.business_name[0]
              : response?.city
              ? "City: " + response.city[0]
              : response?.contact_email
              ? "Contact Email: " + response.contact_email[0]
              : response?.contact_first_name
              ? "Contact First Name: " + response.contact_first_name[0]
              : response?.contact_last_name
              ? "Contact Last Name: " + response.contact_last_name[0]
              : response?.contact_person
              ? "Contact Person: " + response.contact_person[0]
              : response?.contact_phone
              ? "Contact Phone: " + response.contact_phone[0]
              : response?.email
              ? "Email: " + response.email[0]
              : response?.phone
              ? "Phone: " + response.phone[0]
              : response?.state
              ? "State: " + response.state[0]
              : "Error",
            "error"
          );
        }
      } catch (e) {
        message.error("SERVER ERROR - 500");
        console.log(e);
      }
    } else {
      const temp = {
        ...basicEditValues,
        id: basicEditValues.id,
        //"fullname": basicEditValues.first_name + " " + basicEditValues.last_name,
        //address1: basicEditValues.address,
        //postalCode: basicEditValues.zip_code,
      };

      delete temp.customer_plan;
      delete temp.profile_picture;
      delete temp.id;

      const response = await Controller.editMember(temp, basicEditValues.id);
      if (response.status < 250) {
        Alert.openNotification(
          response.message ? response.message : "Successful",
          "success"
        );
        props.getMemberData();
        setOpenModalEdit(false);
        setBasicEditValues({
          first_name: "",
          last_name: "",
          contact_first_name: "",
          contact_last_name: "",
          business_name: "",
          address: "",
          city: "",
          state: "",
          email: "",
          phone: "",
          business_email: "",
          business_phone: "",
          contact_email: "",
          contact_phone: "",
          zip_code: "",
          country: "ca",
          dateOfBirth: null,
        });
      } else {
        Alert.openNotification(
          response.detail[0] ? response.detail[0] : "Error",
          "error"
        );
      }
    }
    setLoadingCreate(false);
  };

  const handleInviteMember = async () => {
    setLoadingCreate(true);

    try {
      const response = await Controller.createInviteMemberNew({
        email: newMember.email,
        first_name: newMember.first_name,
        last_name: newMember.last_name,
        phone: newMember.phone,
      });
      if (response.status < 250) {
        Alert.openNotification(
          response.message ? response.message : "Successful",
          "success"
        );
        props.getMemberData();
        setVisibleCreateMemberModal(false);
        setNewMember({
          first_name: "",
          last_name: "",
          address: "",
          city: "",
          state: "",
          email: "",
          phone: "",
          zip_code: "",
          country: "ca",
          dateOfBirth: null,
        });
      } else {
        console.log(response);
        Alert.openNotification(
          response.json.phone
            ? response.json.phone[0]
            : response.detail[0]
            ? response.detail[0]
            : "Error",
          "error"
        );
      }
    } catch (error) {
      console.log(error);
    }

    setLoadingCreate(false);
  };

  const handleCreateMember = async () => {
    setLoadingCreate(true);
    if (props.memberType == "business") {
      const payload = {
        business_name: newMember.business_name,
        address: newMember.address || null,
        city: newMember.city || null,
        state: newMember.state || null,
        email: newMember.email,
        phone: newMember.phone,
        zip_code: newMember.zip_code || null,
        office: localStorage.getItem("selectedOffice"),
        notify_member: position == "invite" ? true : false,
        contact_person: {
          first_name: newMember.contact_person?.first_name,
          last_name: newMember.contact_person?.last_name,
          email: newMember.contact_person?.email,
          phone: newMember.contact_person?.phone,
        },
      };
      try {
        const response = await Controller.createNewMemberBusiness(payload);
        if (response.status < 250) {
          Alert.openNotification(
            response.message ? response.message : "Successful",
            "success"
          );
          props.getMemberData();
          setVisibleCreateMemberModal(false);
          setNewMember({
            first_name: "",
            last_name: "",
            business_name: "",
            address: "",
            city: "",
            state: "",
            email: "",
            phone: "",
            zip_code: "",
            country: "ca",
            dateOfBirth: null,
            contact_person: {
              first_name: "",
              last_name: "",
              phone: "",
              email: "",
            },
          });
        } else {
          console.log(response);
          Alert.openNotification(
            response.json.detail
              ? response.json.detail[0]
              : response.json.business_name
              ? "business_name: " + response.json.business_name[0]
              : response.json["email or phone"]
              ? "email or phone: " + response.json["email or phone"][0]
              : response.json.address
              ? "address: " + response.json.address[0]
              : response.json.city
              ? "city: " + response.json.city[0]
              : response.json.state
              ? "state: " + response.json.state[0]
              : response.json.email
              ? "email: " + response.json.email[0]
              : response.json.phone
              ? "phone: " + response.json.phone[0]
              : response.json.contact_person
              ? "contact_person: " + response.json.contact_person[0]
              : JSON.stringify(response.json),
            "error"
          );
        }
      } catch (error) {
        console.log(error);
      }
      setLoadingCreate(false);
      return;
    }

    const temp = {
      first_name: newMember.first_name,
      last_name: newMember.last_name,
      address: newMember.address || null,
      city: newMember.city || null,
      state: newMember.state || null,
      email: newMember.email,
      phone: newMember.phone,
      zip_code: newMember.zip_code || null,
      country: newMember.country,
      dateOfBirth: newMember.dateOfBirth || null,
      fullname: newMember.first_name + " " + newMember.last_name,
      address1: newMember.address || null,
      postalCode: newMember.zip_code || null,
      notify_member: position == "invite" ? true : false,
    };
    try {
      const response = await Controller.createNewMemberNew(temp);
      if (response.status < 250) {
        Alert.openNotification(
          response.message ? response.message : "Successful",
          "success"
        );
        props.getMemberData();
        setVisibleCreateMemberModal(false);
        setNewMember({
          first_name: "",
          last_name: "",
          business_name: "",
          address: "",
          city: "",
          state: "",
          email: "",
          phone: "",
          zip_code: "",
          country: "ca",
          dateOfBirth: null,
          contact_person: {
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
          },
        });
      } else {
        console.log(response);
        Alert.openNotification(
          response.json.detail
            ? response.json.detail[0]
            : response.json.first_name
            ? "first_name: " + response.json.first_name[0]
            : response.json.business_name
            ? "first_name: " + response.json.business_name[0]
            : response.json["email or phone"]
            ? "email or phone: " + response.json["email or phone"][0]
            : response.json.last_name
            ? "last_name: " + response.json.last_name[0]
            : response.json.address
            ? "address: " + response.json.address[0]
            : response.json.city
            ? "city: " + response.json.city[0]
            : response.json.state
            ? "state: " + response.json.state[0]
            : response.json.email
            ? "email: " + response.json.email[0]
            : response.json.phone
            ? "phone: " + response.json.phone[0]
            : response.json.postalCode
            ? "postalCode: " + response.json.postalCode[0]
            : response.json.address1
            ? "address1: " + response.json.address1[0]
            : response.json.fullname
            ? "fullname: " + response.json.fullname[0]
            : JSON.stringify(response.json),
          "error"
        );
      }
    } catch (error) {
      console.log(error);
    }

    setLoadingCreate(false);
  };

  const handleOpenDatePicker = (e) => {
    setOpenDatePicker(e);
  };

  const handleCloseAddMember = () => {
    setNewMember({
      first_name: "",
      last_name: "",
      business_name: "",
      address: "",
      city: "",
      state: "",
      email: "",
      phone: "",
      zip_code: "",
      country: "ca",
      dateOfBirth: null,
      contact_person: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      },
    });
    setVisibleCreateMemberModal(false);
  };

  return (
    <>
      <Flex
        direction="column"
        w="100%"
        overflowX={{ sm: "scroll", lg: "hidden" }}
      >
        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify="space-between"
          w="100%"
          px="22px"
          pb="20px"
          mb="10px"
          boxShadow={
            !props.loading && "0px 40px 58px -20px rgba(112, 144, 176, 0.26)"
          }
        >
          <Row>
            {/* <Text
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.showList != "member" && props.setShowList("member");
              }}
              color={props.showList == "member" ? textColor : "gray"}
              fontSize="xl"
              fontWeight={props.showList == "member" ? "600" : "400"}
            >
              Members List
            </Text> */}
            <Radio.Group
              value={props.memberType || "individual"}
              onChange={(e) => {
                props.memberType != e.target.value &&
                  props.setMemberType &&
                  props.setMemberType(e.target.value);
              }}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio.Button value="individual">Individual</Radio.Button>
              <Radio.Button value="business">Business</Radio.Button>
            </Radio.Group>
            {/* <Divider type="vertical" />
            <Text
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.showList != "invite" && props.setShowList("invite");
              }}
              color={props.showList != "member" ? textColor : "gray"}
              fontSize="xl"
              fontWeight={props.showList != "member" ? "600" : "400"}
            >
              Invitation list
            </Text> */}
          </Row>

          <Flex align="center" gap="10px">
            <Search
              className="custom-search"
              placeholder="Search"
              onSearch={props.onSearch}
              onChange={(e) => {
                if (!e.target.value.trim()) {
                  props.onSearch("");
                }
              }}
              size="large"
              enterButton
            />
            <style>
              {`
                .custom-search .ant-input { height: 40px !important; }
                .custom-search .ant-input-search-button { height: 40px !important; }
              `}
            </style>
            <Button
              align="center"
              justifyContent="center"
              bg={bgButton}
              _hover={bgHover}
              _focus={bgFocus}
              _active={bgFocus}
              w="40px"
              h="40px"
              onClick={() => {
                setVisibleCreateMemberModal(true);
              }}
              lineHeight="100%"
              borderRadius="10px"
            >
              <Icon as={FaPlus} color={iconColor} w="24px" h="24px" />
            </Button>
          </Flex>
        </Flex>
        {props.loading ? (
          <Row justify={"center"} style={{ display: "flex" }}>
            <Spin />
          </Row>
        ) : (
          <Table {...getTableProps()} variant="simple" color="gray.500">
            <Thead>
              {headerGroups.map((headerGroup, index) => (
                <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <>
                      {column.id == "action" && props.showList == "invite" ? (
                        <></>
                      ) : (
                        <Th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          pe="10px"
                          key={index}
                          borderColor="transparent"
                        >
                          <Flex
                            justify="space-between"
                            align="center"
                            fontSize={{ sm: "10px", lg: "12px" }}
                            color="gray.400"
                          >
                            {column.render("Header")}
                          </Flex>
                        </Th>
                      )}
                    </>
                  ))}
                </Tr>
              ))}
            </Thead>

            <Tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, index) => {
                      let data = "";
                      if (cell.column.Header === "Name") {
                        const detailPath =
                          props.memberType === "business"
                            ? `/admin/business-member-detail/${cell.row.original.id}`
                            : `/admin/member-detail/${cell.row.original.id}`;
                        data = (
                          <Flex align="center">
                            <Avatar
                              src={cell.row.original.profile_picture}
                              w="30px"
                              h="30px"
                              me="8px"
                            />
                            <NavLink to={detailPath}>
                              <Text
                                fontSize="sm"
                                color="brand.500"
                                _hover={{ textDecoration: "underline" }}
                                fontWeight="600"
                              >
                                {cell.row.original.first_name
                                  ? cell.row.original.first_name +
                                    " " +
                                    cell.row.original.last_name
                                  : cell.row.original.business_name}
                              </Text>
                            </NavLink>
                          </Flex>
                        );
                      } else if (
                        cell.column.Header === "Action" &&
                        props.showList == "member"
                      ) {
                        data = (
                          <Row>
                            <NavLink
                              to={
                                props.memberType === "business"
                                  ? `/admin/business-member-detail/${cell.row.original.id}`
                                  : `/admin/member-detail/${cell.row.original.id}`
                              }
                            >
                              <Text
                                color={"brand.500"}
                                fontSize="sm"
                                style={{ cursor: "pointer" }}
                                fontWeight="500"
                              >
                                View
                              </Text>
                            </NavLink>
                            <Divider type="vertical" />
                            <Text
                              color={"green"}
                              fontSize="sm"
                              style={{ cursor: "pointer" }}
                              fontWeight="500"
                              onClick={() => {
                                if (props.memberType == "business") {
                                  setBasicEditValues({
                                    ...cell.row.original,
                                    contact_first_name:
                                      cell.row.original?.contact_person
                                        ?.first_name,
                                    contact_last_name:
                                      cell.row.original?.contact_person
                                        ?.last_name,
                                    contact_phone:
                                      cell.row.original?.contact_person?.phone,
                                    contact_email:
                                      cell.row.original?.contact_person?.email,
                                  });
                                } else {
                                  setBasicEditValues(cell.row.original);
                                }
                                setOpenModalEdit(true);
                              }}
                            >
                              Edit
                            </Text>
                            <Divider type="vertical" />
                            <Text
                              color={"red"}
                              fontSize="sm"
                              style={{ cursor: "pointer" }}
                              fontWeight="500"
                            >
                              <Popconfirm
                                title="Delete the task"
                                description={
                                  props.memberType == "business"
                                    ? "Are you sure to delete this business member?"
                                    : "Are you sure to delete this member?"
                                }
                                onConfirm={() => {
                                  setLoading(true);
                                  handleDeleteMember(
                                    cell.row.original.id
                                  ).finally(() => setLoading(false));
                                }}
                                okButtonProps={{
                                  loading: loading,
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <div>Delete</div>
                              </Popconfirm>
                            </Text>
                          </Row>
                        );
                      } else if (
                        cell.column.Header === "Contact Person" &&
                        props.memberType == "business"
                      ) {
                        data = (
                          <Flex align="center">
                            <Text fontSize="sm" fontWeight="600">
                              {cell.row.original?.contact_person?.first_name
                                ? cell.row.original?.contact_person
                                    ?.first_name +
                                  " " +
                                  (cell.row.original?.contact_person
                                    ?.last_name || "")
                                : "-"}
                            </Text>
                          </Flex>
                        );
                      } else {
                        data = (
                          <Flex align="center">
                            <Text
                              fontSize="sm"
                              onClick={() => {
                                console.log(cell.row.original);
                                console.log(cell.column.Header.toLowerCase());
                              }}
                              fontWeight="600"
                            >
                              {
                                cell.row.original[
                                  cell.column.Header.toLowerCase()
                                ]
                              }
                            </Text>
                          </Flex>
                        );
                      }
                      return (
                        <Td
                          {...cell.getCellProps()}
                          key={index}
                          fontSize={{ sm: "14px" }}
                          minW={{ sm: "150px", md: "200px", lg: "auto" }}
                          borderColor="transparent"
                        >
                          {data}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </Flex>

      <Modal
        title="Add Member"
        open={visibleCreateMemberModal && props.memberType != "business"}
        footer={null}
        onCancel={handleCloseAddMember}
        width={500}
        style={{
          top: 20,
          marginBottom: openDatePicker ? "220px" : "",
        }}
      >
        <label className="formLabel">
          Add member details manually or invite them via email
        </label>

        {position === "add" || 1 == 1 ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleCreateMember();
            }}
          >
            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>
                  First Name
                </label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="first_name"
                  placeholder="Alex"
                  value={newMember.first_name}
                  //required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>
                  Last Name
                </label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="last_name"
                  placeholder="Doe"
                  value={newMember.last_name}
                  //required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>
                  Phone
                </label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  value={newMember.phone}
                  //required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>
                  Email
                </label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="email"
                  placeholder="alex.doe@gmail.com"
                  value={newMember.email}
                  //required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Country</label>
                <Select
                  className="inputs"
                  name="country"
                  placeholder="country"
                  value={newMember.country}
                  onChange={(value) =>
                    setNewMember({ ...newMember, country: value })
                  }
                  //required
                >
                  <Option value="ca">Canada</Option>
                  <Option value="us">United States of America</Option>
                </Select>
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Birthdate</label>
                <DatePicker
                  placement="bottomLeft"
                  onOpenChange={handleOpenDatePicker}
                  className="inputs"
                  onChange={(date, dateString) =>
                    setNewMember({ ...newMember, dateOfBirth: dateString })
                  }
                  placeholder="Select a birth date"
                  //required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Address</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="address"
                  placeholder="256 wfi street"
                  value={newMember.address}
                  //required
                  minLength={10}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">City</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="city"
                  placeholder="New york"
                  value={newMember.city}
                  //required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">State</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="state"
                  placeholder="Ny"
                  value={newMember.state}
                  //required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Zip Code</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="zip_code"
                  placeholder="12345"
                  value={newMember.zip_code}
                  //required
                />
              </Col>
            </Row>
            <Row
              style={{ width: "100%", marginBottom: "10px", marginTop: "8px" }}
            >
              <Checkbox
                checked={position == "add" ? false : true}
                onChange={(e) =>
                  setPosition(e.target.checked ? "invite" : "add")
                }
              >
                Notify member to review information
              </Checkbox>
            </Row>
            <div
              className="btnBox"
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "15px",
              }}
            >
              <AntdButton
                onClick={handleCloseAddMember}
                className="white-btn create-payment-request-btn"
              >
                Close
              </AntdButton>
              <AntdButton
                htmlType="submit"
                type="primary"
                loading={loadingCreate}
                className="login-btn create-payment-request-btn"
                style={{ marginLeft: "5px", minWidth: "120px" }}
              >
                {loadingCreate ? "Creating..." : "Create"}
              </AntdButton>
            </div>
          </form>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleInviteMember();
            }}
          >
            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">First Name</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="first_name"
                  placeholder="Alex"
                  value={newMember.first_name}
                  required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Last Name</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="last_name"
                  placeholder="Doe"
                  value={newMember.last_name}
                  required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Phone</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  value={newMember.phone}
                  required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Email</label>
                <Input
                  className="inputs"
                  onChange={handleChange}
                  type="text"
                  name="email"
                  placeholder="alex.doe@gmail.com"
                  value={newMember.email}
                  required
                />
              </Col>
            </Row>

            <div
              className="btnBox"
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "15px",
              }}
            >
              <AntdButton
                onClick={handleCloseAddMember}
                className="white-btn create-payment-request-btn"
              >
                Close
              </AntdButton>
              <AntdButton
                htmlType="submit"
                type="primary"
                loading={loadingCreate}
                className="login-btn create-payment-request-btn"
                style={{ marginLeft: "5px", minWidth: "120px" }}
              >
                {loadingCreate ? "Inviting..." : "Invite"}
              </AntdButton>
            </div>
          </form>
        )}
      </Modal>

      <Modal
        title="Create Business Member"
        open={visibleCreateMemberModal && props.memberType == "business"}
        footer={null}
        onCancel={handleCloseAddMember}
        width={600}
        style={{
          top: 20,
          marginBottom: openDatePicker ? "220px" : "",
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleCreateMember();
          }}
        >
          <div className="custom-divider">
            <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
              Business Information
            </span>
            <div className="line"></div>
          </div>

          <Row gutter={[25]}>
            <Col span={24}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Business Name
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="business_name"
                placeholder="Example Business"
                value={newMember.business_name}
              />
            </Col>
          </Row>

          <Row gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Business Email
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="email"
                name="email"
                placeholder="business@example.com"
                value={newMember.email}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Business Phone
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="phone"
                placeholder="1234567890"
                value={newMember.phone}
              />
            </Col>
          </Row>

          <Row gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Address</label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="address"
                placeholder="123 Example Street"
                value={newMember.address}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">City</label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="city"
                placeholder="Example City"
                value={newMember.city}
              />
            </Col>
          </Row>

          <Row gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">State</label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="state"
                placeholder="Example State"
                value={newMember.state}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Zip Code</label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="zip_code"
                placeholder="A1A1A1"
                value={newMember.zip_code}
              />
            </Col>
          </Row>

          <div className="custom-divider">
            <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
              Contact Person
            </span>
            <div className="line"></div>
          </div>

          <Row gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                First Name
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="contact_person.first_name"
                placeholder="John"
                value={newMember.contact_person?.first_name || ""}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Last Name
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="contact_person.last_name"
                placeholder="Doe"
                value={newMember.contact_person?.last_name || ""}
              />
            </Col>
          </Row>

          <Row gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Contact Phone
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="text"
                name="contact_person.phone"
                placeholder="0987654321"
                value={newMember.contact_person?.phone || ""}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">
                <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                Contact Email
              </label>
              <Input
                className="inputs"
                onChange={handleChange}
                type="email"
                name="contact_person.email"
                placeholder="person@example.com"
                value={newMember.contact_person?.email || ""}
              />
            </Col>
          </Row>

          <Row
            style={{ width: "100%", marginBottom: "10px", marginTop: "8px" }}
          >
            <Checkbox
              checked={position == "add" ? false : true}
              onChange={(e) => setPosition(e.target.checked ? "invite" : "add")}
            >
              Notify member to review information
            </Checkbox>
          </Row>

          <div
            className="btnBox"
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "15px",
            }}
          >
            <AntdButton
              onClick={handleCloseAddMember}
              className="white-btn create-payment-request-btn"
            >
              Close
            </AntdButton>
            <AntdButton
              htmlType="submit"
              type="primary"
              loading={loadingCreate}
              className="login-btn create-payment-request-btn"
              style={{ marginLeft: "5px", minWidth: "120px" }}
            >
              {loadingCreate ? "Creating..." : "Create"}
            </AntdButton>
          </div>
        </form>
      </Modal>

      {/* Edit Modal */}
      <Modal
        title={
          props.memberType == "business" ? `Edit Business Member` : `Edit Member`
        }
        open={openModalEdit}
        footer={null}
        onCancel={handleCloseEditMember}
        width={props.memberType == "business" ? 600 : 500}
        style={{
          top: 20,
          marginBottom: openDatePicker ? "220px" : "",
        }}
      >
        {props.memberType == "business" ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleEditMember();
            }}
          >
            <div className="custom-divider">
              <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
                Business Information
              </span>
              <div className="line"></div>
            </div>
            <Row gutter={[25]}>
              <Col span={24}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Business Name
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="business_name"
                  placeholder="Example Business"
                  value={basicEditValues.business_name}
                />
              </Col>
            </Row>

            <Row gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Business Email
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="email"
                  name="email"
                  placeholder="business@example.com"
                  value={basicEditValues.email}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Business Phone
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="tel"
                  name="phone"
                  placeholder="1234567890"
                  value={basicEditValues.phone}
                />
              </Col>
            </Row>

            <Row gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Address</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="address"
                  placeholder="123 Example Street"
                  value={basicEditValues.address}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">City</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="city"
                  placeholder="Example City"
                  value={basicEditValues.city}
                />
              </Col>
            </Row>

            <Row gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">State</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="state"
                  placeholder="Example State"
                  value={basicEditValues.state}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Zip Code</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="zip_code"
                  placeholder="A1A1A1"
                  value={basicEditValues.zip_code}
                />
              </Col>
            </Row>

            <div className="custom-divider">
              <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
                Contact Person
              </span>
              <div className="line"></div>
            </div>
            <Row gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  First Name
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="contact_first_name"
                  placeholder="John"
                  value={basicEditValues.contact_first_name}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Last Name
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="contact_last_name"
                  placeholder="Doe"
                  value={basicEditValues.contact_last_name}
                />
              </Col>
            </Row>

            <Row gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Contact Phone
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="tel"
                  name="contact_phone"
                  placeholder="0987654321"
                  value={basicEditValues.contact_phone}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">
                  <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
                  Contact Email
                </label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="email"
                  name="contact_email"
                  placeholder="person@example.com"
                  value={basicEditValues.contact_email}
                />
              </Col>
            </Row>

            <div
              className="btnBox"
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "15px",
              }}
            >
              <AntdButton
                onClick={handleCloseEditMember}
                className="white-btn create-payment-request-btn"
              >
                Close
              </AntdButton>
              <AntdButton
                htmlType="submit"
                type="primary"
                loading={loadingCreate}
                className="login-btn create-payment-request-btn"
                style={{ marginLeft: "5px", minWidth: "120px" }}
              >
                {loadingCreate ? "Editing..." : "Edit"}
              </AntdButton>
            </div>
          </form>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleEditMember();
            }}
          >
            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">First Name</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="first_name"
                  placeholder="Alex"
                  value={basicEditValues.first_name}
                  required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Last Name</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="last_name"
                  placeholder="Doe"
                  value={basicEditValues.last_name}
                  required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Phone</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  value={basicEditValues.phone}
                  required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Email</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="email"
                  placeholder="alex.doe@gmail.com"
                  value={basicEditValues.email}
                  required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Address</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="address"
                  placeholder="256 wfi street"
                  value={basicEditValues.address}
                  required
                  minLength={10}
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">City</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="city"
                  placeholder="New york"
                  value={basicEditValues.city}
                  required
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[25]}>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">State</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="state"
                  placeholder="Ny"
                  value={basicEditValues.state}
                  required
                />
              </Col>
              <Col span={windowDimensions.width < 450 ? 24 : 12}>
                <label className="formLabel">Zip Code</label>
                <Input
                  className="inputs"
                  onChange={handleChangeEdit}
                  type="text"
                  name="zip_code"
                  placeholder="12345"
                  value={basicEditValues.zip_code}
                  required
                />
              </Col>
            </Row>

            <div
              className="btnBox"
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "15px",
              }}
            >
              <AntdButton
                onClick={handleCloseEditMember}
                className="white-btn create-payment-request-btn"
              >
                Close
              </AntdButton>
              <AntdButton
                htmlType="submit"
                type="primary"
                loading={loadingCreate}
                className="login-btn create-payment-request-btn"
                style={{ marginLeft: "5px", minWidth: "120px" }}
              >
                {loadingCreate ? "Editing..." : "Edit"}
              </AntdButton>
            </div>
          </form>
        )}
      </Modal>
    </>
  );
}

export default MemberTable;
